<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/role">Perfis de acesso</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Atualizar perfil</li>
                <li class="breadcrumb-item active" aria-current="page">{{ role.name }}</li>
            </ol>
        </nav>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Permissões de acesso</h6> <button
                            class="btn btn-warning btn-sm" @click="loadData()"><i class="fa fa-undo"></i> Recarregar
                            dados</button>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive limitHeight" ref="bottomOfTable">
                            <input class="form-control border-bottom-primary mb-3" v-model="searchString"
                                placeholder="Buscar permissão..." />
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(permission, index) in filteredItemsRole" :key="index">

                                        <td>{{ permission.name_translate }} </td>
                                        <td><input type="checkbox" class="flipswitch" :value="permission.name" checked
                                                v-model="checkPermissions"></td>

                                    </tr>
                                    <tr v-for="(permission, index) in filteredItemsApi" :key="index">
                                        <td>{{ permission.name_translate }} </td>
                                        <td><input type="checkbox" class="flipswitch" :value="permission.name"
                                                v-model="checkPermissions"></td>

                                    </tr>
                                    <tr v-show="permissions_roles.length <= 0 && permissions_api.length <= 0">
                                        <td colspan="5" class="text-center">Nenhum registro encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row mt-3">
                            <div class="col-xl-12 col-md-12 col-sm-12">
                                <button type="button" class="btn btn-info" @click="updatePermission">
                                    <i class="fa fa-check"></i> Atualizar permissões</button>
                                <span class="text-center mt-n5 information-center hidden-mobile">Role para ver mais permissões</span>
                                <i class="fa fa-arrow-down mt-2 fa-2x text-center pulse-icon hidden-mobile" @click="scrollTable"></i>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'

export default {
    directives: { mask },
    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            permissions_roles: [],
            permissions_api: [],
            permissions: [],
            checkPermissions: [],
            role: { uuid: '' },
            searchString: '',
            bottom:0
        }
    },
    mounted() {
        const role_id = this.$route.params.id;
        this.role.uuid = role_id;
        this.loadData();
    },
    computed: {
        filteredItemsRole() {
            if (!this.searchString) {
                return this.permissions_roles;
            }
            const lowerCaseSearchString = this.searchString.toLowerCase();
            return this.permissions_roles.filter(item =>
                item.name_translate.toLowerCase().includes(lowerCaseSearchString)
            );
        },

        filteredItemsApi() {
            if (!this.searchString) {
                return this.permissions_api;
            }
            const lowerCaseSearchString = this.searchString.toLowerCase();
            return this.permissions_api.filter(item =>
                item.name_translate.toLowerCase().includes(lowerCaseSearchString)
            );
        },
    },

    methods: {
        onCancel() { },

        capitalizeValue(value) {
            return capitalize(value);
        },

        loadData() {
            this.isLoading = true;
            api.get('/role/rolePermission/' + this.role.uuid)
                .then((response) => {
                    this.isLoading = false;
                    this.permissions_roles = response.data.permissions_role;
                    this.permissions_api = response.data.permissions_api;
                    this.permissions = { ...this.permissions_roles, ...this.permissions_api }
                    this.role = response.data.role;
                    this.permissions_roles.forEach(role => {
                        this.checkPermissions.push(role.name);
                    });

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        updatePermission(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            const formData = new FormData();
            formData.append('permissions', this.checkPermissions);
            api.post('/role/syncRolePermission/' + this.role.uuid, formData)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Perfil atualizado!",
                        type: 'success'
                    });

                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })
        },

        scrollTable() {
            const container = this.$refs.bottomOfTable;
            if (container) {
                this.bottom += 100;
                container.scrollTop = parseInt(this.bottom);
            }
        }

    },
}
</script>

<style>
.flipswitch {
    position: relative;
    background: white;
    width: 160px;
    height: 40px;
    -webkit-appearance: initial;
    border-radius: 3px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    outline: none;
    font-size: 14px;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    cursor: pointer;
    border: 1px solid #ddd;
}

.flipswitch:after {
    position: absolute;
    top: 5%;
    display: block;
    line-height: 32px;
    width: 45%;
    height: 90%;
    background: #fff;
    box-sizing: border-box;
    text-align: center;
    transition: all 0.3s ease-in 0s;
    color: black;
    border: #888 1px solid;
    border-radius: 3px;
}

.flipswitch:after {
    left: 2%;
    content: "Negar";
    background: #920000;
    color: #fff;
}

.flipswitch:checked:after {
    left: 53%;
    content: "Permitir";

    background: #02855d;
    color: #fff;
}

.limitHeight {
    max-height: 500px;
    overflow-y: auto;
    scrollbar-color: darkblue lightgrey;
    border-bottom: 1px solid #e0e0e0;
}

.limitHeight table {
    width: 100%;
    /* Ensure the table fills the container width */
    border-collapse: collapse;
    /* Optional: for better table styling */
}

.information-center {
    display: block;
    margin: 0 auto;
    width: 100%;
}

.fa-arrow-down {
    display: block;
    margin: 0 auto;
    width: 50px;
    /* Example width for the icon, adjust as needed */
}

.pulse-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    /* Makes it a circle */
    position: relative;
    /* For positioning pseudo-elements if needed */
    animation: pulse 2s infinite;
    /* Apply the pulse animation */
}

@keyframes pulse {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(210, 0, 0, 0.7);
        /* Initial shadow */
    }

    70% {
        transform: scale(1.1);
        /* Scale up */
        box-shadow: 0 0 0 15px rgba(210, 0, 0, 0);
        /* Expand and fade out shadow */
    }

    100% {
        transform: scale(1);
        /* Return to original size */
        box-shadow: 0 0 0 0 rgba(210, 0, 0, 0);
        /* Reset shadow */
    }
}

@media (max-width: 575.98px) {
    .hidden-mobile {
        display: none;
    }
}
</style>